import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';
import {Link, Redirect} from 'react-router-dom';

import $ from 'jquery';
import ReactImageFallback from "react-image-fallback";
import { Line, ComposedChart, Area , ResponsiveContainer } from 'recharts';
import { BUILDER_PATH, IMGIX_PATH, PUB_PLAYER_PATH, UNPUB_PLAYER_PATH } from '../../constants';
import * as vignetsReducers from "../../reducers/vignets";

var dateFormat = require('dateformat');

const data = [
    {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
    {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
    {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
    {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
    {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
    {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
    {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
];


class ListItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            vignetId: '',
            vignet_name: '',
            selected_class : '',
            userDet : JSON.parse(window.localStorage.userDet)
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.selectVigs = this.selectVigs.bind(this);
        this.triggerPop = this.triggerPop.bind(this);
        this.getVigProps = this.getVigProps.bind(this);
        this.blockDetailView =  this.blockDetailView.bind(this);

    }


    componentDidMount() {

        let index = this.props.id;

        let obj = this;

        $('.stat-button').off('click').on('click',function(e){
            e.stopPropagation();
            $('.panel-block').removeClass('flip');
            $(this).parent('.panel-button-block').parent('.face.front').parent('.panel-block').addClass('flip');
            let id = $(this).data('id');
            obj.getVigProps(id);
            obj.getVigProps(id);

            let graph_params = { vignet_id: id, type : 'week' , show : 'list'};

            obj.props.fetchGraphData(graph_params);
        });

        $('.back-button').on('click',function(e){
            e.stopPropagation();
            $(this).parent('.panel-button-block').parent('.face.back').parent('.panel-block').removeClass('flip');
        });

        $('.vig-modal').on('click',function(e){
            e.stopPropagation();
        });

        var _ = this;

        $('.select-ico').eq(index).on('click',function(e){
            e.stopPropagation();
            let vigId = $(this).data('id');
            console.log(vigId);
            _.selectVigs(vigId);

        });


        /*$('.input-tags').selectize({
            plugins: ['remove_button'],
            persist: false,
            create: true,
            render: {
                item: function(data, escape) {
                    return '<div>' + escape(data.text) + '</div>';
                }
            }
        });*/

    }

    handleInputChange(event) {

        this.setState({
            [event.target.name]: event.target.value
        });

    }

    selectVigs(vignetId) {

        this.setState(prevState => ({
            selected_class: (prevState.selected_class === '')? 'selected' : ''

        }));
        this.props.selectVignets(vignetId);
    }

    triggerPop(e, vignet) {
        e.stopPropagation();
        this.setState({redirect : true});
        //this.props.showDetailPopup(vignet);
    }

    getVigProps(vigId){
        let data = { vignet_id : vigId, section : 'list', index : 0, section_name : 'list'};
       // console.log(data)
        this.props.allVignetsProps(data);
       // console.log(this.props.vignetsData.vignetProps);
    }

    blockDetailView(e, buildUrl) {
        e.preventDefault();
        e.stopPropagation();
        if(this.props.itemType === 'vignets' ) {
            window.open(buildUrl);
        }
    }

    viewPlaylist(e, viewUrl) {
        e.preventDefault();
        e.stopPropagation();
        window.open(viewUrl);

    }

    /* updateVigName(vignetId) {
         var vigData = { userid : this.state.userDet.user_id  , title :this.state.vignet_name, le_id :vignetId};

         if(this.state.vignet_name !='' ) {
             let vigUpdated = vignetService.updateVigName(vigData);

             vigUpdated.then((response) => {

                 if(response.data.status === "1")
                 {

                 }
             });
         }

     }*/


    render() {
        let item = this.props.detail;
        let index = this.props.id;
        item.selected_class = "";
        // onClick={(e) => { this.selectVigs(e,vignet.vignet_id)}}

        item.builderUrl = '#';
        item.playerUrl = '#';

        if(this.props.itemType === 'vignets' ) {
            item.builderUrl = BUILDER_PATH+item.uniqueId+'/'+item.user_id;
            item.playerUrl = PUB_PLAYER_PATH+item.uniqueId+'/'+item.user_id;
            item.imgSrc = IMGIX_PATH+'assets/slider/cf'+item.uniqueId+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        }
        else if(this.props.itemType === 'playlist' ) {
            item.builderUrl = '#playlist/'+item.uniqueId;
            item.imgSrc = IMGIX_PATH+'assets/slider/'+item.uniqueId+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        }
        else if(this.props.itemType === 'user' ) {
            item.imgSrc = IMGIX_PATH+'assets/slider/'+item.uniqueId+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        }

        if (this.state.redirect) {
            if(this.props.itemType === 'vignets' ) {
                return <Redirect to={'/vignet/'+item.uniqueId}/>;
            }
            else if(this.props.itemType === 'playlist' ) {
                return <Redirect to={'/playlist/'+item.uniqueId}/>;
            }
        }

        let eventTracks = this.props.vignetsData?this.props.vignetsData.vignetProps:undefined;

        let graphData =  this.props.vignetsData.graphData?this.props.vignetsData.graphData:[];


        return (
            <div id={'item'+item.uniqueId} className="panel-block panel-col" onClick={ (e) => {this.triggerPop(e,item)}}>
                <div className="face front">
                    <div className="image-upload-block">

                        <div className="image-up" >

                            <img
                                src={item.imgSrc}
                                alt="cool image should be here"
                                className="my-image" />
                            <div className="upload-select">

                                {this.props.itemType === 'vignets' &&
                                <a onClick={(e) => this.blockDetailView(e, item.builderUrl)} href="javascript:;"
                                   target="_blank">
                                    <button className={"icon-lib edit-button"}></button>
                                </a>
                                }
                                {this.props.itemType === 'playlist' &&
                                <a href={item.builderUrl}>
                                    <button className={"icon-lib edit-button"}></button>
                                </a>
                                }


                            </div>
                        </div>
                    </div>
                    <div className="title-wrapper edit-title">
                        <h5 className="title-box" >{item.name}</h5>
                        {/*<span className="highlight"></span>*/}
                        {/*<span className="bar"></span>*/}
                    </div>
                    <div className={"description-wrapper " + (this.props.itemType === 'user' ? " no-border" : "")}>
                        <div className="input-desc-block">
                            <span className="description-box">{item.display_name} </span>
                        </div>
                        <div className="input-desc-block">
                            <span className="description-box">{item.date_created ? dateFormat(item.date_created,"d mmm yyyy").toUpperCase() :'' }</span>
                        </div>
                    </div>
                    {this.props.itemType === 'vignets' &&
                    <div className="panel-button-block">
                        <button className="panel-button stat-button" data-id={item.uniqueId}>Statistics</button>
                    </div>
                    }
                    {this.props.itemType === 'playlist' &&
                    <div className="panel-button-block">
                        <button className="panel-button" onClick={(e) =>this.viewPlaylist(e,item.listVignetUrl)}>VIEW PLAYLIST</button>
                    </div>
                    }
                    {/*this.props.itemType === 'user' &&
                    <div className="panel-button-block">
                        <button className="panel-button">VIEW MORE</button>
                    </div>
                    */}
                    {this.props.itemType === 'vignets' &&
                    <button data-id={item.uniqueId}
                            className={this.state.selected_class + " icon-lib-list select-ico"}></button>
                    }
                </div>

                <div className="face back">
                    <div className="stat-header">
                        <h5 className="subheader">{item.name}</h5>
                    </div>
                    <div className="track-count-block">
                        <div className="ind-track-count">
                            <p className="track-text">Click</p>
                            <h5>{eventTracks?eventTracks.click_count:0}</h5>
                        </div>
                        <div className="ind-track-count">
                            <p className="track-text">Views</p>
                            <h5>{eventTracks?eventTracks.view_count:0}</h5>
                        </div>
                        <div className="ind-track-count btn-track">
                            <a onClick={(e)=> this.blockDetailView(e,item.builderUrl)} href="javascript:;" target="_blank"><button className={"icon-lib edit-button"}></button></a>
                        </div>
                    </div>

                    <div className="track-table">
                        <div className="ind-track-table">
                            <span className="left-graph-text">Page View</span>
                            <span className="right-graph-text">{eventTracks?eventTracks.pageview_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">HOTSPOT</span>
                            <span className="right-graph-text">{eventTracks?eventTracks.hotspot_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">IMAGE CLICK</span>
                            <span className="right-graph-text">{eventTracks?eventTracks.imageclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">TEXT CLICK</span>
                            <span className="right-graph-text">{eventTracks?eventTracks.textclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">VIDEO</span>
                            <span className="right-graph-text">{eventTracks?eventTracks.video_count:0}</span>
                        </div>
                    </div>

                    <div className="chart-block">
                        <ResponsiveContainer width={212} height={46} aspect="width">
                            <ComposedChart  data={graphData} >
                                <Area type="monotone" dataKey="Visits" fill="#8884d8" stroke="#8884d8" />
                                <Line type="monotone" dataKey="Visits" stroke="#ff7300" />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="panel-button-block left-align">
                        <button className="panel-button back-button">Back</button>
                    </div>
                </div>
            </div>

        );
    }


}


ListItem.propTypes = {
    detail: PropTypes.object.isRequired,
    id:PropTypes.number.isRequired,
    selected_ids : PropTypes.array.isRequired,
    showDetailPopup : PropTypes.func
}


function mapStateToProps(state) {
    return {
        vignetsData  :vignetsReducers.getVignetsData(state)
    };

}
export default  withRouter(connect(mapStateToProps,{
    selectVignets : vignetsActions.chooseVignets,
    allVignetsProps : vignetsActions.getVignetProps,
    fetchGraphData : vignetsActions.fetchGraphData,
})(ListItem));



// WEBPACK FOOTER //
// ./src/components/common/listItem.js